import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import { LoadScript } from '@react-google-maps/api';

import Landing from 'pages/Landing/Landing';
import Enquiry from 'pages/Enquiry/Enquiry';
import HostRegistration from 'pages/HostRegistration/HostRegistration';
import SearchHost from 'pages/SearchHost/SearchHost';
import RenoCalculator from 'pages/RenoCalculator/RenoCalculator';
import HostAwardsListing from 'pages/HostAwardsListing/HostAwardsListing';
import HostProfileListing from 'pages/HostProfileListing/HostProfileListing';
import HostProfile from 'pages/HostProfile/HostProfile';
import BuildingStatusFrom from 'pages/BuildingStatusForm/BuildingStatusForm';
import StandardLayout from 'layouts/StandardLayout/StandardLayout';
import { original } from 'utils/theme';
import { buildHostRegistrationRoute, buildAwardsRoute, buildAwardsHostProfileRoute, buildHostProfileRoute, buildHostProfileListingRoute } from 'utils/routes';
import './index.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => (
  <LoadScript id="script-loader" googleMapsApiKey="AIzaSyA7scv5SSve4lERPPPLQcs5u8wcJ5XzSLc" libraries={['places']}>
    <ThemeProvider theme={original}>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route exact path="/enquiry" component={Enquiry} />
          <Route path={buildHostRegistrationRoute()} component={HostRegistration} />
          <Route exact path="/search-host" component={SearchHost} />
          <Route exact path="/reno-calculator" component={RenoCalculator} />
          <StandardLayout>
            <Route exact path="/what-is-your-building-status" component={BuildingStatusFrom} />
            <Route exact path="/" component={Landing} />
            <Route exact path={buildAwardsRoute()} component={HostAwardsListing} />
            <Route exact path={buildHostProfileListingRoute()} component={HostProfileListing} />
            <Route exact path={buildHostProfileRoute()} component={HostProfile} />
            <Route exact path={buildAwardsHostProfileRoute()} component={HostProfile} />
          </StandardLayout>
        </Switch>
      </Router>
    </ThemeProvider>
  </LoadScript>
);

ReactDOM.render(<App />, document.getElementById('root'));
